const routes = {
    '/': 'Home',
    '/dashboard': 'Dashboard',
    '/dashboard/2': 'Dashboard 2',
    '/dashboard/2/1': 'Dashboard 2 1',
    '/translate/tags': 'Tags',
    '/dashboard/1': 'Dashboard 1'
};
export default routes;
